import React from "react";
import classes from "./Welcome.module.scss";
import { useNavigate } from "react-router";
import * as r from "../../../../constants/routes";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import ListSteps from "../../../../components/Lists/ListSteps";
import RoundButton from "../../../../components/Buttons/RoundButton";
import { useTranslation } from "react-i18next";
import { APP_NAME } from "../../../../constants/defaults";

export default function Welcome() {
  const { t } = useTranslation();

  const history = useNavigate();

  return (
    <>
      {/* <PageHeader
        title={t("global.welcome_to_the_platform") + " " + APP_NAME + "!"}
        subtitle={t("global.understanding_how_we_work")}
      /> */}
      <PageMain centerStretch>
        <section className={classes.Welcome}>
          <ListSteps
            centerVert
            steps={[
              "Agora que você já fez o treinamento, vamos realizar a reavaliação",
              "Tente fazer cada um dos testes sem interrupções, caso precise de uma pausa, a faça apenas entre um teste e outro",
              "É fundamental que você use fones de ouvido",
              // t("global.info_welcome_you_will_do_a_second_avaliation"),
            ]}
          />
          <RoundButton
            text={t("global.go_to_revaluation")}
            title={t("global.go_to_revaluation")}
            onClick={() => history(r.R_U_TESTS)}
          />
        </section>
      </PageMain>
    </>
  );
}
